import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-data-table-options',
	templateUrl:'./DataTableOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./DataTableOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DataTableOptionsPluginCompPage
{
	mdContent_889 = `\`\`\`java
import com.jwebmp.plugins.datatable.options.DataTableOptions;
\`\`\``;
	mdContent_890 = `\`\`\`java
DataTableOptions()
\`\`\``;
	mdContent_891 = `\`\`\`java
DataTableOptions&lt;?&gt; opts = new DataTableOptions&lt;&gt;();
opts.setPaging(true)
    .setPageLength(25)
    .setPagingType(DataTablesPagingTypes.full_numbers)
    .setOrdering(true)
    .setOrderMulti(true);
\`\`\``;
	mdContent_892 = `\`\`\`java
DataTableOptions&lt;?&gt; opts = new DataTableOptions&lt;&gt;();
opts.setServerSide(true)
    .setProcessing(true)
    .setSearchDelay(400);
\`\`\``;
	mdContent_893 = `\`\`\`java
DataTableOptions&lt;?&gt; opts = new DataTableOptions&lt;&gt;();
opts.setScrollX(true)
    .setScrollCollapse(true)
    .setStateSave(true)
    .setStateDuration(3600);
\`\`\``;
}
